import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Checkbox, Form, Input, notification, Select} from 'antd';

import {getStaff, updateStaff} from './actions';
import {bindActionCreators} from "redux";
import {getDescriptionFromError} from "../utils/errors";
import {getStaffRoles} from "../StaffRole/actions";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateStaffForm extends Component {
  componentDidMount() {
    this._loadStaff();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.staffId !== this.props.match.params.staffId) {
      this._loadStaff();
    }
  }

  _loadStaff = () => {
    const {staffId} = decodeParams(this.props.match.params);
    this.props.getStaffRoles();
    this.props.getStaff({staffId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {staffId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.updateStaff({...values, staffId})
        .then(this.goBack)
        .catch(err => notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        }));
    });
  };

  render() {
    const {staff, staffRoles, form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    const {name, availableAtAllDispensaries, staffRoleId, password} = staff;
    return (
      <Card title="Update Staff">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Available At All Dispensaries"
          >
            {getFieldDecorator('availableAtAllDispensaries', {
              rules: [],
              initialValue: availableAtAllDispensaries,
              valuePropName: 'checked'
            })(
              <Checkbox />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Role"
          >
            {getFieldDecorator('staffRoleId', {
              rules: [{required: true, type: 'string'}],
              initialValue: staffRoleId
            })(
              <Select placeholder="Select a role">
                {staffRoles.map(({staffRoleId, name}) => <Option key={staffRoleId} value={staffRoleId}>{name}</Option>)}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Password"
          >
            {getFieldDecorator('password', {
              rules: [{required: true, min: 4}],
              initialValue: password
            })(
              <Input type="password" />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Staff
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdateStaffForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  getStaff: PropTypes.func.isRequired,
  staff: PropTypes.object.isRequired,
  selectedDispensaryId: PropTypes.string.isRequired,
  staffRoles: PropTypes.array.isRequired,
  updateStaff: PropTypes.func.isRequired,
  getStaffRoles: PropTypes.func.isRequired,
};

const UpdateStaffPage = Form.create()(UpdateStaffForm);

const mapStateToProps = state => ({
  loading: state.staff.staffLoading || state.staff.updatingStaff,
  staff: state.staff.staff || {},
  selectedDispensaryId: state.dispensary.selectedDispensaryId,
  staffRoles: state.staffRole.staffRoles,
});

const mapDispatchToProps = dispatch => ({
  getStaff: payload => (dispatch(getStaff(payload))),
  updateStaff: bindActionCreators(updateStaff, dispatch),
  getStaffRoles: bindActionCreators(getStaffRoles, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateStaffPage);



// WEBPACK FOOTER //
// ./src/Staff/UpdateStaffPage.js